import { useState, useCallback } from "react";
import api from "@/lib/api";

export default function useTaskActivity(task) {
  const [activity, setActivity] = useState([]);
  const [actHasMore, setActHasMore] = useState(false);
  const [actBefore, setActBefore] = useState(null);
  const [loadingOlder, setLoadingOlder] = useState(false);

  const refreshActivity = useCallback(() => {
    if (!task) return;
    api.get(`/tasks/${task.task_id}/activity`, { params: { limit: 20 } })
      .then((r) => {
        setActivity(r.data);
        setActHasMore(r.headers["x-has-more"] === "1");
        setActBefore(r.headers["x-next-before"] || null);
      })
      .catch(() => {});
  }, [task]);

  const loadOlderActivity = useCallback(async () => {
    if (!task || !actBefore) return;
    setLoadingOlder(true);
    try {
      const r = await api.get(`/tasks/${task.task_id}/activity`, { params: { limit: 20, before: actBefore } });
      setActivity((prev) => [...r.data, ...prev]);
      setActHasMore(r.headers["x-has-more"] === "1");
      setActBefore(r.headers["x-next-before"] || null);
    } catch (e) { console.error("Failed to load older activity:", e); }
    finally { setLoadingOlder(false); }
  }, [task, actBefore]);

  const resetActivity = useCallback(() => {
    setActivity([]);
    setActHasMore(false);
    setActBefore(null);
  }, []);

  return { activity, actHasMore, loadingOlder, refreshActivity, loadOlderActivity, resetActivity };
}
